import { render, staticRenderFns } from "./AddPermissions.vue?vue&type=template&id=d895c116&"
import script from "./AddPermissions.vue?vue&type=script&lang=js&"
export * from "./AddPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports